import UserProfileIcon from '../Icons/UserProfileIcon';
import HeaderLogOutIcon from '../Icons/HeaderLogOutIcon';
import React from 'react';
import HeaderBackIcon from '../Icons/HeaderBackIcon';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';

interface IPageHeader {
  props: any;
  title: string;
  logOutModal: (params: boolean) => void;
  editModal: (params: boolean) => void;
  resultsModal?: (params: boolean) => void;
  isEditOpen: boolean;
  isFullOpen: boolean;
  isResultsOpen?: boolean;
  children?: React.ReactNode;
  resultsTitle?: string;
}
export default function PageHeader({
  props,
  title,
  logOutModal,
  editModal,
  resultsModal = () => false,
  isEditOpen,
  isResultsOpen,
  isFullOpen,
  children,
  resultsTitle,
}: IPageHeader) {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div
      className={clsx(
        props.user
          ? 'tablet:w-[calc(100%-350px)]'
          : 'tablet:w-[calc(100%-8px)]',
        'z-10 tablet:pt-10 tablet:pb-6 bg-white tablet:fixed top-0 right-0 tablet:mr-5'
      )}
    >
      <div className={'tablet:container'}>
        <div
          className={
            'flex gap-3 tablet:items-center max-tablet:flex-col max-tablet:gap-4 tablet:min-h-[40px] justify-between'
          }
        >
          <div
            className={
              'relative z-10 bg-white max-tablet:fixed max-tablet:w-[calc(100vw-8px)] top-0 group-[.fullModalOpen]:max-tablet:z-50 max-tablet:py-2 before before:absolute before:bottom-0 before:w-screen max-tablet:before:w-full before:left-0 before:h-[1px] before:bg-grayLight tablet:before:hidden'
            }
          >
            <div className={'max-tablet:container'}>
              <div className={'max-tablet:flex items-center justify-between'}>
                {isMobile && props.user && (
                  <button
                    type={'button'}
                    className={
                      'rounded-full p-3.5 bg-grayLight max-smallMobile:p-2.5 flex-shrink-0'
                    }
                    onClick={() => {
                      isEditOpen
                        ? editModal(false)
                        : isResultsOpen
                        ? resultsModal(false)
                        : editModal(true);
                    }}
                  >
                    {isFullOpen ? <HeaderBackIcon /> : <UserProfileIcon />}
                  </button>
                )}
                <h1
                  className={clsx(
                    'h1 text-center',
                    isEditOpen && isMobile && 'flex items-center gap-3'
                  )}
                >
                  {(!isEditOpen && !isResultsOpen) || !isMobile ? title : null}
                  {isMobile && isResultsOpen && resultsTitle}
                  {isMobile && isEditOpen && (
                    <>
                      <span>Edit your profile</span>
                      <span
                        className={clsx(
                          'text-12 font-semibold px-1 py-0.5 rounded-4 text-white',
                          props.user?.subscriptionTier === 'Free'
                            ? 'bg-green'
                            : 'bg-gradient-to-r from-[#D13A0A] to-[#FFA901]'
                        )}
                      >
                        {props.user?.subscriptionTier === 'Free'
                          ? 'Free'
                          : 'Unlimited'}
                      </span>
                    </>
                  )}
                </h1>
                {isMobile && props.user && (
                  <button
                    type={'button'}
                    className={
                      'rounded-full p-3.5 bg-grayLight max-smallMobile:p-2.5 flex-shrink-0'
                    }
                    onClick={() => logOutModal(true)}
                  >
                    <HeaderLogOutIcon />
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className={'max-tablet:container max-tablet:pt-20'}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
